export default __webpack_public_path__ + "images/secondary-doc-upload.png";